import React, { useEffect, useRef, useState } from "react";
import "./HappyCustomersSlider.css";
import api from "../Api.js";
import ImageLightbox from "./Helping Component/ImageZoom";

export default function HappyCustomersSlider() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const sliderRef = useRef(null);

  // State for the API data (array of customer entries)
  const [galleryData, setGalleryData] = useState([]);

  // Fetch data
  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await api.get("/happy-customers");
        if (response.data.status) {
          setGalleryData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
  }, []);

  // ❌ Auto-scroll effect removed

  // Navigation handlers
  const nextSlide = () => {
    sliderRef.current?.scrollBy({
      left: sliderRef.current.offsetWidth / 4,
      behavior: "smooth",
    });
  };

  const prevSlide = () => {
    sliderRef.current?.scrollBy({
      left: -sliderRef.current.offsetWidth / 4,
      behavior: "smooth",
    });
  };

  // Extract all image URLs from all customer entries
  const allImages = galleryData.flatMap((item) =>
    item.images.map((img) => img.url)
  );

  // Handler when an image is clicked – opens lightbox with all images,
  // placing the clicked image first.
  const handleImageClick = (clickedUrl) => {
    const otherImages = allImages.filter((url) => url !== clickedUrl);
    setCurrentImages([clickedUrl, ...otherImages]);
    setLightboxOpen(true);
  };

  return (
    <section className="joyraj-happy-slider">
      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />

      <div className="joyraj-happy-header">
        <h3>Our Happy Customers</h3>
        <div className="joyraj-happy-controls">
          <button onClick={prevSlide} aria-label="Previous">
            ◀
          </button>
          <button onClick={nextSlide} aria-label="Next">
            ▶
          </button>
        </div>
      </div>

      <div className="joyraj-happy-track" ref={sliderRef}>
        {allImages.map((url, index) => (
          <div
            className="joyraj-happy-card"
            key={index}
            onClick={() => handleImageClick(url)}
          >
            <img src={url} alt="Happy Customer" loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  );
}